/* bogo-variant-image-sync.js
 * products-clinic-optional-bundle-v2.js が生成するバンドルカードの補完。
 *  1) バリエーション変更時に、カード内の商品画像を追従させる
 *     （本体スクリプトの refreshPrices() は価格のみ更新し img を触らないため）
 *  2) 同時に、左の商品ギャラリーをそのバリエーションの画像へ切り替える
 * 本体スクリプトには手を入れないので、再ビルドで上書きされない。
 */
(function () {
  /* ── 適用する商品ハンドルをここで明示的に限定する ──
     ここに書いた商品以外では、このスクリプトは一切動作しない。
     他の商品にも適用したくなったら、この配列に handle を足すだけでよい。 */
  var ENABLED_HANDLES = [
    'elifa-clinic-coupon-morpheus8-manjaro-2-5mg-4pcs-9980'  // モフィウス8 × マンジャロ 特別セット
  ];

  var VM = null;            // { variantId: mediaId }
  var loading = false;
  var lastVariant = null;   // 直近で同期したバリエーション
  var handle = (location.pathname.split('/products/')[1] || '').split(/[?#]/)[0];

  if (ENABLED_HANDLES.indexOf(handle) === -1) return;   // 対象外ページでは即終了

  function loadMap() {
    if (VM || loading || !handle) return;
    // バンドルが無いページでは何もしない
    if (!document.querySelector('.ab-bogo-product-container')) return;
    loading = true;
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var m = {};
        ((j && j.variants) || []).forEach(function (v) {
          if (v.featured_media) m[String(v.id)] = String(v.featured_media.id);
        });
        VM = m;
        sync();
      })
      .catch(function () { VM = {}; });
  }

  /* カード内の各行の画像を Appstle 側の現在値に合わせる */
  function syncRowImages() {
    var card = document.querySelector('.bogo-custom-container');
    if (!card) return;
    var rows = card.querySelectorAll('.bogo-product');
    var conts = document.querySelectorAll('.ab-bogo-product-container');
    for (var i = 0; i < conts.length && i < rows.length; i++) {
      var srcEl = conts[i].querySelector('img');
      var img = rows[i].querySelector('.bogo-product-img');
      if (img && srcEl && srcEl.src && img.src !== srcEl.src) img.src = srcEl.src;
    }
  }

  /* 商品ギャラリーを選択中バリエーションの画像へ。
     バリエーションが変わった時だけ動かす（手動スワイプを妨げない） */
  function syncGallery() {
    if (!VM) return;
    var vs = document.querySelector('.ab-bogo-product-container .ab-bogo-variant-select');
    if (!vs || !vs.value) return;
    var v = String(vs.value);
    if (v === lastVariant) return;
    lastVariant = v;
    var mid = VM[v];
    if (!mid) return;
    var item = document.querySelector('.product-gallery-item[data-media-id="' + mid + '"]');
    var slider = document.querySelector('css-slider');
    if (!item || !slider || typeof slider.changeSlide !== 'function') return;
    var ix = parseInt(item.getAttribute('data-index'), 10);
    if (!isNaN(ix) && slider.index !== ix) slider.changeSlide(ix);
  }

  function sync() { syncRowImages(); syncGallery(); }

  var timer = null;
  function schedule() { clearTimeout(timer); timer = setTimeout(function () { loadMap(); sync(); }, 150); }

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });

  /* Appstle は select の change 後に非同期で価格・画像を差し替えるので、少し待ってからも見る */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.tagName === 'SELECT') {
      loadMap();
      setTimeout(sync, 400);
      setTimeout(sync, 1200);
      setTimeout(sync, 2500);
    }
  }, true);

  loadMap();
})();